import React from "react";
// import "../components/Spinner.css";
import "./Spinner.css";

const Spinner = () => {
  return (
    <div className="flex justify-center items-center w-screen h-screen">
      <div className="spinner"></div>
    </div>
  );
};

export default Spinner;
